// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Blur mask is forced in Dialog.js (\`mask={{ blur: true }}\`, dev-supplied \`mask\` is discarded)
   this class only sets the tint since antd's own \`-mask-blur\` class supplies the backdrop-filter. */
.vecDialogMask__Dialog-module--Tlbf_ {
    background-color: rgba(38, 33, 28, 0.45) !important; /* --color-neutral-900 tint, not themed via var() so it survives even without vector's ConfigProvider */
}

/* Safety net so a \`width\` bigger than the viewport can't ever produce horizontal overflow /
   an unusably cramped dialog on small screens — this beats antd's inline \`width\` style
   regardless of what a consumer passes in, since !important beats an un-!important inline style. */
.ant-modal {
    max-width: calc(100vw - var(--space-lg)) !important;
}

.vecDialogTitle__Dialog-module--rEnIY {
    display: flex;
    align-items: center;
    gap: var(--space-xs);
}

/* antd's default title (16px) reads too close in weight to the body text at dialog scale — bumped
   to match base.css's h5 scale (18px/600/1.35) for consistency with the rest of vector's type
   scale, rather than a one-off arbitrary value. Global (not scoped to .vecDialog) for the same
   reason as the \`.ant-modal\` max-width rule above — className lands on \`.ant-modal\` itself, and
   \`.ant-modal-title\` is a descendant inside \`.ant-modal-content\`, not that same element. */
.ant-modal-title {
    font-size: 18px !important;
    line-height: 1.35 !important;
}

.ant-modal-close {
    transform: translateY(4px);
}

.ant-modal-close::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 44px;
    height: 44px;
    transform: translate(-50%, -50%);
}

.vecDialogDragHandle__Dialog-module--h13H1 {
    display: flex;
    align-items: center;
    gap: var(--space-xs);
    width: 100%;
    padding-right: var(--space-lg);
    cursor: move;
}

.vecDialogDragHandle__Dialog-module--h13H1:focus-visible {
    outline: 2px solid var(--color-surface-brand);
    outline-offset: 2px;
}

.vecDialogDragHandleTitle__Dialog-module--kyU8I {
    flex: 1;
    min-width: 0;
}

.vecDialogDragHandleIcon__Dialog-module--sJbYm {
    flex-shrink: 0;
    color: var(--color-text-tertiary);
    /* MenuDotsBoldIcon is 3 dots in a horizontal row (its usual "more options" orientation) —
       rotated so it reads as a drag indicator instead. */
    transform: rotate(90deg);
}

.vecSrOnly__Dialog-module--zi8gz {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}
`, "",{"version":3,"sources":["webpack://./vector/src/Dialog/Dialog.module.css"],"names":[],"mappings":"AAAA;oGACoG;AACpG;IACI,mDAAmD,EAAE,uGAAuG;AAChK;;AAEA;;mGAEmG;AACnG;IACI,mDAAmD;AACvD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;;;;2FAI2F;AAC3F;IACI,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,6CAA6C;IAC7C,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iCAAiC;IACjC;yDACqD;IACrD,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb","sourcesContent":["/* Blur mask is forced in Dialog.js (`mask={{ blur: true }}`, dev-supplied `mask` is discarded)\n   this class only sets the tint since antd's own `-mask-blur` class supplies the backdrop-filter. */\n.vecDialogMask {\n    background-color: rgba(38, 33, 28, 0.45) !important; /* --color-neutral-900 tint, not themed via var() so it survives even without vector's ConfigProvider */\n}\n\n/* Safety net so a `width` bigger than the viewport can't ever produce horizontal overflow /\n   an unusably cramped dialog on small screens — this beats antd's inline `width` style\n   regardless of what a consumer passes in, since !important beats an un-!important inline style. */\n:global(.ant-modal) {\n    max-width: calc(100vw - var(--space-lg)) !important;\n}\n\n.vecDialogTitle {\n    display: flex;\n    align-items: center;\n    gap: var(--space-xs);\n}\n\n/* antd's default title (16px) reads too close in weight to the body text at dialog scale — bumped\n   to match base.css's h5 scale (18px/600/1.35) for consistency with the rest of vector's type\n   scale, rather than a one-off arbitrary value. Global (not scoped to .vecDialog) for the same\n   reason as the `.ant-modal` max-width rule above — className lands on `.ant-modal` itself, and\n   `.ant-modal-title` is a descendant inside `.ant-modal-content`, not that same element. */\n:global(.ant-modal-title) {\n    font-size: 18px !important;\n    line-height: 1.35 !important;\n}\n\n:global(.ant-modal-close) {\n    transform: translateY(4px);\n}\n\n:global(.ant-modal-close)::before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 44px;\n    height: 44px;\n    transform: translate(-50%, -50%);\n}\n\n.vecDialogDragHandle {\n    display: flex;\n    align-items: center;\n    gap: var(--space-xs);\n    width: 100%;\n    padding-right: var(--space-lg);\n    cursor: move;\n}\n\n.vecDialogDragHandle:focus-visible {\n    outline: 2px solid var(--color-surface-brand);\n    outline-offset: 2px;\n}\n\n.vecDialogDragHandleTitle {\n    flex: 1;\n    min-width: 0;\n}\n\n.vecDialogDragHandleIcon {\n    flex-shrink: 0;\n    color: var(--color-text-tertiary);\n    /* MenuDotsBoldIcon is 3 dots in a horizontal row (its usual \"more options\" orientation) —\n       rotated so it reads as a drag indicator instead. */\n    transform: rotate(90deg);\n}\n\n.vecSrOnly {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vecDialogMask": `vecDialogMask__Dialog-module--Tlbf_`,
	"vecDialogTitle": `vecDialogTitle__Dialog-module--rEnIY`,
	"vecDialogDragHandle": `vecDialogDragHandle__Dialog-module--h13H1`,
	"vecDialogDragHandleTitle": `vecDialogDragHandleTitle__Dialog-module--kyU8I`,
	"vecDialogDragHandleIcon": `vecDialogDragHandleIcon__Dialog-module--sJbYm`,
	"vecSrOnly": `vecSrOnly__Dialog-module--zi8gz`
};
export default ___CSS_LOADER_EXPORT___;
